import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../api';

export default class Modaluseredittorob2 extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",


   id_send:"",//
   id_commentex:"",//
   id_ex:"",//
   id_expertbn:"",//
   sentbackeditword:null,//
   sentbackeditpdf:null,//
   sentbackguarantee:null,
   filewordcomment_expertcheck:'',

   id_articlepsf2:'',
   id_empbn2:'',
   nameuserbn2:'',
   send_uploadewordbn2:null,
   send_uploadepdfbn2:null,
   send_uploadepdfbn3:null,

   dateaddbn2:'',
   statusbn2:','
}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleChange33 = this.handleChange33.bind(this);
this.handleChange4 = this.handleChange4.bind(this);

this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()

 //this.props.selectex();
}

handleChangetype(event) {    this.setState({comment_bn: event.target.value});  }


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_articlepsf2:this.props.id_articlepsf2,
                       id_empbn2:this.props.id_empbn2,
                       nameuserbn2:this.props.nameuserbn2,
                      // id_expertbn:this.props.id_experten,
                      // filewordcomment_expertcheck:this.props.filewordcomment_expert,
        })
    //   this.setState({ id_bn:this.props.expert_id})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }




  handleChange(event) {    this.setState({fileexpert: event.target.files[0]});  }


  handleChange2(event) {    this.setState({send_uploadewordbn2: event.target.files[0]});  }
  handleChange3(event) {    this.setState({send_uploadepdfbn2: event.target.files[0]});  }
  handleChange33(event) {    this.setState({send_uploadepdfbn3: event.target.files[0]});  }

  handleChange4(event) {    this.setState({sentbackguarantee: event.target.files[0]});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_articlepsf2", this.state.id_articlepsf2);
      datafrm.append("id_empbn2", this.state.id_empbn2);
      datafrm.append("nameuserbn2", this.state.nameuserbn2);
      datafrm.append("send_uploadewordbn2", this.state.send_uploadewordbn2);
      datafrm.append("send_uploadepdfbn2", this.state.send_uploadepdfbn2);
      datafrm.append("send_uploadepdfbn3", this.state.send_uploadepdfbn3);
      datafrm.append("dateaddbn2", dates);
      datafrm.append("statusbn2", '1');
    //  datafrm.append("filewordcomment_expertcheck", this.state.filewordcomment_expertcheck);
      
      api.post("registercon/updatearticleeditexrob2",datafrm,{
        headers: {
            'content-type': 'multipart/form-data'
        }
      })

   .then(res => {
   
  
            if (res.data === '200') {
                Swal.fire({
                title: 'บันทึกไฟล์ปรับแก้ไขสำเร็จ',
                text: "Successfully saved modified file.",
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง'
                  }).then((result) => {
                      if (result.isConfirmed) {
                          this.props.list()
                          this.toggle()
                      }
                  })
            
            }else{
                    message.error("อัพโหลไฟล์ไม่สำเร็จ!")
            }
  })




}, 400);

  //this.props.updateat();
 // this.toggle()
  //this.getExpert()

  }

  

    render() {
      //  console.log(this.state.filewordcomment_back)

        return (
            <MDBContainer className='text-left'>
            <MDBBtn color="deep-purple" onClick={this.toggle} size='sm'>อัพโหลดไฟล์ปรับแก้</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>
              อัพโหลดไฟล์ปรับแก้
                {/* {this.props.namearticla}{this.props.id_send} */}
                </MDBModalHeader>
              <MDBModalBody>
              <div>

              {/* <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุจำนวนเงิน" required />
              </div> */}
              {/* <p>อัพโหลดไฟล์แบบประเมิน .pdf</p> */}
                {/* <MDBInput   group   type="file" validate error="wrong"
                                        success="right"  name="file2" value={this.state.value} onChange={this.handleChange2} required/> */}

                            <div className="mb-2">
                            <label><strong className='blue-text'>อัพโหลดไฟล์ PSF02 ที่ปรับแก้ไขแล้ว <MDBIcon icon="file-word" /> .docx</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        required />
                            </div>
                            <div className="mb-2">
                            <label><strong className='red-text'>อัพโหลดไฟล์ PSF02 ที่ปรับแก้ไขแล้ว <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div>

                             <div className="mb-2">
                            <label><strong className='red-text'>อัพโหลดไฟล์ตารางเปรียบเทียบที่ปรับแก้ไขแล้ว <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange33}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div>


              </div>

              </MDBModalBody>

             
              <MDBModalFooter>
                 {this.state.send_uploadewordbn2 == null  ? <><MDBBtn color="primary" disabled >บันทึก</MDBBtn> </> :<>  <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn></> }
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}


